'use server'

import { createClient, createServiceClient } from '@repo/db/server'

export async function updateEmail(newEmail: string) {
  const supabase = await createClient()
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return { error: 'Oturum bulunamadı' }

  if (newEmail === user.email) {
    return { error: 'Yeni e-posta mevcut e-posta ile aynı.' }
  }

  const admin = createServiceClient()
  const { error } = await admin.auth.admin.updateUserById(user.id, { email: newEmail, email_confirm: true })
  if (error) return { error: error.message }

  return { success: true, message: 'E-posta adresiniz başarıyla güncellendi.' }
}

export async function updatePassword(currentPassword: string, newPassword: string) {
  const supabase = await createClient()
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return { error: 'Oturum bulunamadı' }

  if (newPassword.length < 6) {
    return { error: 'Şifre en az 6 karakter olmalıdır.' }
  }

  // Mevcut şifreyi doğrula
  const { error: signInError } = await supabase.auth.signInWithPassword({
    email: user.email!,
    password: currentPassword,
  })

  if (signInError) {
    return { error: 'Mevcut şifre hatalı.' }
  }

  const { error } = await supabase.auth.updateUser({ password: newPassword })
  if (error) return { error: error.message }

  return { success: true, message: 'Şifreniz başarıyla güncellendi.' }
}
